module.exports = __webpack_public_path__ + "assets/9279247238400a94d696929a7c9bfec9.png";